import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function BasicCard({ heading, amount }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isCustomBreakpoint = useMediaQuery("(max-width:315px)");
  return (
    <Card
      sx={{
        minWidth: {
          xs: 100, // Extra-small devices (phones)
          sm: 150, // Small devices (tablets)
          md: 200, // Medium devices (desktops)
        },
        background: "#008080",
        color: "#fff",
        "& .MuiCardContent-root": {
          padding: "6px 10px !important",
        },
        ...(isCustomBreakpoint && {
          minWidth: 150, // Custom style for screens <= 320px
        }),
      }}
    >
      <CardContent className="text-center">
        <Typography
          className="mb-2"
          variant={isSmallScreen ? "h6" : "h5"}
          component="h6"
          sx={{
            fontSize: {
              xs: 16, // Extra-small devices (phones)
              sm: 18, // Small devices (tablets)
              md: 24, // Medium devices (desktops)
            },
            mb: {
              xs: 1, // Extra-small devices (phones)
              sm: 2, // Small devices (tablets)
            },
          }}
        >
          {heading}
        </Typography>
        {/* {isSmallScreen ? "" : <br />} */}
        <Typography
          variant={isSmallScreen ? "h6" : "h5"}
          component="h6"
          sx={{
            fontSize: {
              xs: 16, // Extra-small devices (phones)
              sm: 18, // Small devices (tablets)
              md: 24, // Medium devices (desktops)
            },
          }}
        >
          {amount ? parseFloat(amount).toFixed(2) : 0}
        </Typography>
      </CardContent>
    </Card>
  );
}
